module.exports = __webpack_public_path__ + "static/media/Chord-Personalities_Target.57f67e24.png";